import Vue from 'vue';

let els;

if ((els = document.querySelectorAll('.anchors-app')).length > 0) {
    for (let i = 0; i < els.length; i++) {
        const el = els[i];

        new Vue({
            el,
            name: 'AnchorsApp',
            components: {},
            data() {
                return {
                    cities: [],
                    opened: false,
                    hash: window.location.hash.substring(1),
                    city: null
                }
            },
            methods: {
                scrollTo(hash, noReplaceHash) {
                    const id = _.camelCase(hash.trim());
                    const navHeight = document.querySelector('nav').getBoundingClientRect().height;
                    const element = document.getElementById(id);

                    if (typeof noReplaceHash === 'undefined' || noReplaceHash === false)
                        window.location.hash = '#' + hash;

                    if (element === null)
                        return;

                    // console.log(navHeight);

                    window.scrollTo({
                        top: element.offsetTop - 185,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            },
            mounted() {
                if (this.hash !== '') {
                    setTimeout(() => {
                        this.scrollTo(this.hash, true);
                    }, 800);
                }
            }
        });
    }
}
